import { Component, Vue } from 'vue-property-decorator';
import { TwoColumnTextVideoBlockViewModel } from './TwoColumnTextVideoModule.types';

import { VideoJsPlayerOptions } from 'video.js';

import { getComponentProps } from '@/utils/vueUtils';

import Cutout from '@/components/CutoutComponent/CutoutComponent.vue';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import VimeoVideoPlayer from '@/components/VimeoVideoPlayer/VimeoVideoPlayer.vue';

import SizeBreakpoints, {
  ImageWidths,
  ImageSizes,
  ImageSize,
} from '@/common/interfaces/SizeBreakpoints';

import DottedLine from '@/assets/icons/dotted-line.svg?inline';
import Plus from '@/assets/icons/plus.svg?inline';
import Minus from '@/assets/icons/minus.svg?inline';

import { Getter } from 'vuex-class';
import { getResizeImage, isDesktopSafari } from '../../utils/commonUtils';

const TwoColumnTextVideoModuleProps = Vue.extend({
  props: getComponentProps<TwoColumnTextVideoBlockViewModel>({
    Title: 'Set sail with a team of world-travelled adventurers',
    Description:
      'Passionate about the geographies they explore (and return to regularly), our expedition teams illuminate each facet through their enthusiasm and knowledge. They are the ones who write the books, they are the locals; they are the experts that knowledgeable explorers want to travel with again and again. They are the best in their fields. Meet them and see why our staff inspires such passion.',
    VideoDescription:
      'Our captains and expedition leaders work in tandem to craft the best itinerary possible.  In fact, many expedition leaders and captains have worked together for years, or even decades. They share a common purpose and synergy that most companies simply can’t match. Miles apart from how a typical cruise ship operates, where a captain and cruise director operate independently and follow the same weekly routes, the collaboration between our captains and expedition leaders directly enhances the quality of your experience, as they work around weather, ice conditions, or other challenges to get you out on exploring adventures. And, you’ll find them just as excited as you are about a spectacular whale encounter or a gorgeous sunset.',
    Video: {
      Url:
        'https://player.vimeo.com/external/378560468.hd.mp4?s=1c92301b24af4b4217cb2f660a37e236cd8d1a2c&profile_id=175',
      Type: 'video/mp4',
      Poster: '/images/moose.jpg',
    },
    BackgroundImage: {
      Url: getResizeImage('fish.png'),
      Alt: 'Fish',
    },
    AlternateImageLayout: false,
  }),
});

@Component({
  components: {
    VimeoVideoPlayer,
    Plus,
    Minus,
    Cutout,
    DottedLine,
    ResponsiveImageRatio,
  },
})
export default class TwoColumnTextVideoModule extends TwoColumnTextVideoModuleProps {
  textIsHidden = true;
  videoIsActive = false;
  ariaPressed = false;

  @Getter isInBreakpoint!: (breakpoints: SizeBreakpoints[] | SizeBreakpoints) => boolean;

  toggleFullCopy() {
    this.textIsHidden = !this.textIsHidden;
    this.ariaPressed = !this.ariaPressed;
  }

  get showText(): boolean {
    return (
      (!this.textIsHidden && this.isInBreakpoint(['xs', 'sm'])) ||
      this.isInBreakpoint(['md', 'lg', 'xl', 'xxl'])
    );
  }

  imageWidths: ImageWidths = {
    def: 449,
    sizes: {
      lg: 430,
      xl: 449,
    },
  };

  get isSafari() {
    return isDesktopSafari();
  }
}
